define('lib/paginator',['jquery'], function ($) {
  var Paginator = function (endpoint, opt) {
    this.endpoint = endpoint;
    this.options = $.extend({}, Paginator.defaults, opt);
    this.count = -1;
    this.start = 1;
    this._data = [];
    this._active = 0; // increment when start a request, decrement when complete
  };

  Paginator.defaults = {
    query: {},
    beginKey: 'begin',
    endKey: 'end',
    countField: 'count',
    dataField: 'data',
    pageSize: 5,
    xform: null // provide a transform function for your data
  };

  function __buildPageData(self, start, records) {
    // data about the current page of results
    // tack it onto self and return it
    // To be used for display purposes only!
    // this is the obj to throw at your HBS tpl
    var itemEnd = start + (self.options.pageSize - 1) > self.count ? self.count : start + (self.options.pageSize - 1);
    self.pageData = {
      itemStart: start,
      itemEnd: itemEnd,
      count: self.count,
      hasNext: itemEnd < self.count,
      hasPrev: start > 1,
      records: records
    };

    return self.pageData;
  }

  // take start, end, count and records generate pageData obj.
  $.extend(Paginator.prototype, {
    // Return bool (has nothing to do w/ paginated data)
    hasMore: function () {
      return this.count === -1 || (this.count >= 0 && this._data.length < this.count);
    },

    // add isActive method to return bool this._active > 0

    // hasNext and hasPrev is used to determine if the endpoint has additional pages of data
    // use it to allow/deny .next() .prev() on click events.
    // Not to be confused with wether or not our currently displayed page of data in our template hasNext/hasPrev
    // to determine if a template hasNext or hasPrev(to hide/show buttons),
    // use the pageData obj that is rendering your current template
    hasNext: function () {
      return this.start <= this.count;
    },

    hasPrev: function () {
      return (this.start - this.options.pageSize) > 1;
    },

    getData: function () {},

    next: function () {
      // Build the params
      var self = this;
      var start = this.start;
      var pageSize = this.options.pageSize;
      var params = $.extend({}, this.options.query);
      params[this.options.beginKey] = this.start;
      params[this.options.endKey] = this.start + (this.options.pageSize - 1);

      function __processQuery(self, start, records) {
        self.start = start + records.length;
        return __buildPageData(self, start, records);
      }

      // Do we have the data already?
      // Look at self._data arr, at indexes (self.start - 1) and (self.start - 1) + self.options.pageSize
      // Do wave those items in self._data already?
      var existingData = self._data.slice(self.start - 1, (self.start - 1) + self.options.pageSize);
      if (existingData.length) {
        return Promise.resolve(__processQuery(self, self.start, existingData)); // pass in self, start, records to avoid emulating response
        // else, return the endpoint promise if we need to actually fetch data
      }
      return this.endpoint(params)
        .then(function (res) {
          // If we have a transform function to use, pass in just the dataField we want to transform
          if (self.options.xform) {
            res[self.options.dataField] = self.options.xform(res[self.options.dataField]);
          }
          var count = res[self.options.countField];
          var records = res[self.options.dataField];
          var startIdx = start - 1;
          var newlen = startIdx + pageSize;
          self._data.length = Math.max(self._data.length, newlen);
          self._data = self._data.slice(0, startIdx).concat(records).concat(self._data.slice(startIdx + pageSize));
          self.count = typeof count === 'number' ? count : -1;
          return __processQuery(self, self.start, records);
        });
    },

    // At this point, this.start is configured for the NEXT page, so we need to subtract pageSize * 2 from it
    prev: function () {
      var idxBegin;
      if (this.start > this.count) {
        // calculate the new beginning index if we're at the end
        var pageCount = Math.ceil(this.count / this.options.pageSize); // number of pages
        idxBegin = ((pageCount * this.options.pageSize) + 1) - (this.options.pageSize * 2) - 1;
      } else {
        idxBegin = ((this.start - 1) - (this.options.pageSize * 2));
      }
      var idxEnd = idxBegin + this.options.pageSize;
      this.start = idxEnd + 1;
      var records = this._data.slice(idxBegin, idxEnd);
      return __buildPageData(this, idxBegin + 1, records);
    },

    data: function () { return this._data; },
    page: function () { return this._data.slice(this.start, this.start + this.options.pageSize); },
    reset: function () {},
  });

  return Paginator;
});

